import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Radio, Button} from 'antd'

import style from './controls.sass'

@inject('store') @observer
class Controls extends Component {
  handleChange = (e) => {
    this.props.store.stockFilter.single.change('custom_logic', e.target.value)
  }
  previewStocks = () => {
    this.props.store.stockFilter.previewStocks()
  }
  addCondition = () => {
    this.props.store.stockFilter.single.addCondition()
  }
  render() {
    const {stockFilter} = this.props.store
    const {loadingTickers} = stockFilter
    const {custom_logic} = stockFilter.single.data

    return(
      <div>
        <div styleName='conditions'>
          <div>
            <label styleName='label'>Select conditions logic:</label>
            <Radio.Group value={custom_logic} onChange={this.handleChange}>
              <Radio.Button value='AND'>
                AND
              </Radio.Button>
              <Radio.Button value='OR'>
                OR
              </Radio.Button>
            </Radio.Group>
          </div>
          <a onClick={this.addCondition}>
            Add New Condition
          </a>
        </div>
        <Button
          type='primary'
          icon='thunderbolt'
          onClick={this.previewStocks}
          loading={loadingTickers}
          styleName='preview-btn'
        >
          Preview Results
        </Button>
      </div>
    )
  }
}

export default Controls
